<!-- Mapová legenda -->
<!-- jakýkoliv další seznam složek - kromě prvních groups-->
<template>
  <v-expansion-panels accordion multiple>
    <template v-for="item in MapLegendTree.groups">
      <v-expansion-panel v-if="Object.values(item.groups).length > 0 ||
        Object.values(item.layers).length > 0
      " :key="item.id">
        <!-- Hlavička -->
        <v-expansion-panel-header class="pa-0" :color="item.color">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-subtitle-1 ml-2" v-html="item.label" />
            </template>
            <span v-html="item.labelsub"></span>
          </v-tooltip>
        </v-expansion-panel-header>
        <v-expansion-panel-content :color="item.color">
          <!-- případné Podsložky -->
          <MapLegendGroups v-if="Object.values(item.groups).length > 0" :MapLegendTree="item" :AssetsUrl="AssetsUrl"
            :MapLayerLegend_view="MapLayerLegend_view" :MapLayerLegend_layerId="MapLayerLegend_layerId"
            :ServiceMap="ServiceMap" @MapLegendRemoveLayer="MapLegendRemoveLayer"
            @MapViewZoomToScale="MapViewZoomToScale" @MapLegendLayerChangeBaseURL="MapLegendLayerChangeBaseURL"
            @MapLayerLegendStaticSet="MapLayerLegendStaticSet" @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet">
          </MapLegendGroups>

          <!-- Mapové vrstvy -->
          <MapLegendItem v-for="child in item.layers" :key="child.id" :MapLegendLayer="child" :AssetsUrl="AssetsUrl"
            :MapLayerLegend_view="MapLayerLegend_view" :MapLayerLegend_layerId="MapLayerLegend_layerId"
            :ServiceMap="ServiceMap" @MapLegendRemoveLayer="MapLegendRemoveLayer"
            @MapViewZoomToScale="MapViewZoomToScale" @MapLegendLayerChangeBaseURL="MapLegendLayerChangeBaseURL"
            @MapLayerLegendStaticSet="MapLayerLegendStaticSet" @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet">
          </MapLegendItem>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "MapLegendGroups",

  props: {
    // Legenda - podřízený seznam složek
    MapLegendTree: Object,
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,
    // id vrstvy, ke které se legenda vztahuje
    MapLayerLegend_layerId: null,
  },

  components: {
    MapLegendItem: () => import("./MapLegendItem.vue"),
  },

  methods: {

    // Změna mapového výřezu na cílové měřítko - volá se funkce n nadřazeném objektu
    MapViewZoomToScale: function (value) {
      this.$emit('MapViewZoomToScale', value);
    },
    // Funkce pro odstranění vrstvy - volá se funkce v nadřazeném objektu
    MapLegendRemoveLayer: function (id) {
      this.$emit('MapLegendRemoveLayer', id);
    },
    // Funkce pro změnu zdroje vrstvy - volá se funkce v nadřazeném objektu
    MapLegendLayerChangeBaseURL: function (id, oldValue, newValue) {
      this.$emit('MapLegendLayerChangeBaseURL', id, oldValue, newValue);
    },
    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendStaticSet', layerId, title, content);
    },
    // Dynamická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendDynamicSet', layerId, title, content);
    },


  },

};
</script>
